import React, { Component, useEffect, useRef, useState } from 'react'
import classNames from 'classnames'

import Button from '../Button/Button'
import Icon from '../Icon2/Icon'

import AdvanceSearchPortal from './AdvanceSearchPortal'
import RenderAdvanceQuery from './RenderAdvanceQuery/RenderAdvanceQuery'
import AdvanceSearchHeader from './AdvancedSearchHeader'

import { buildQueryObjectForAdvCase } from './util/queryBuilder'
import {
  setCounterForAdvanceQuery,
  notify,
  getInitAdvQueryArray,
  validateAdvanceQuery,
  getQueryType
} from './util/helper'
import { updateSelectedContentTypeStatus, advance_query_errors } from './util/advanceQueryEntries'
import { advanceQueryParser } from './util/QueryParser/QueryParser'

import './AdvancedSearch.css'

const localizedData = {
  key: [{ label: 'Localized In', value: '$localization' }],
  operator: [{ label: 'Localized In', value: '$localization' }],
  value: [{ label: 'Any Locales', value: [{ label: 'Any Locales', value: '$any' }] }],
  queryType: 'localizedInLabel'
  // nextQuery: 'inLocalized',
  // isQueryCompleted: true
}

const LoaderV2 = ({ }) => {
  return (
    <div
      className="Table__loader"
      data-test-id="cs-table-loader"
      style={{
        width: '100%',
        height: '100%',
        position: 'absolute',
        background: '#f5f5f591'
      }}>
      <div className="Table__loader_content">
        <Icon icon="PurpleLoader" className="Table__loader-svg" />
        <div className="Table__loader-desc">Fetching details...</div>
      </div>
    </div>
  )
}
//imp do not put this inside its a special case tested otherwise returs undefined
let queryArrayLength
const getQueryArrayLengthByCursor = (advanceQueryArray, cursorY) => {
  for (let queryObj of advanceQueryArray) {
    let foundQueryObject = queryObj.queryArray.find(rawQuery => rawQuery.queryCursorY === cursorY)
    if (queryObj.cursorY === cursorY) {
      queryArrayLength = 1
    }
    else if (queryObj.queryArray.length && foundQueryObject) {
      queryArrayLength = foundQueryObject.queryType === "localizedInLabel" ? 2 : 3
    }

    else if (queryObj.children.length) {
      getQueryArrayLengthByCursor(queryObj.children, cursorY)
    }
  }

  return queryArrayLength
}


function InfoBanner({ handleInfoBannerAction }) {
  const [visible, setVisible] = useState(handleInfoBannerAction && handleInfoBannerAction({ action: 'getBannerState' }));

  if (!visible) return null;


  const onClickDoNotShow = () => {
    setVisible(false)
    handleInfoBannerAction && handleInfoBannerAction({ action: 'setBannerState', value: false })
  }

  return (
    <div className='info-banner-wrapper' >
      <div className='info-banner flex-v-center' data-test-id="cs-advance-search-info-banner">
        <div className='flex-v-center info-banner-icon-wrapper'>
          <Icon version="v2" icon="Information" size="medium" />
          <span className='banner-massage'>Use Advanced Search with existing filters—or add filters afterward to refine results.</span>
        </div>
        <div className='flex-v-center'>
          <Button
            className='info-banner-dnd-button'
            testId="cs-advance-search-info-banner-dnd-button"
            buttonType="tertiary"
            version="v2"
            onClick={onClickDoNotShow}
            onlyIcon={true}>
            Do not show this again
          </Button>
          <Button
            testId="cs-advance-search-info-banner-close"
            buttonType="light"
            size="regular"
            version="v2"
            onClick={() => setVisible(false)}
            onlyIcon={true}>
            <Icon version="v2" icon="CloseNoborder" size="medium" />
          </Button>
        </div>
      </div>
    </div>
  );
}


export class AdvancedSearch extends Component<any, any> {
  state: any = {
    advanceQueryArray: getInitAdvQueryArray(),
    errorMessage: '',
    queryObjectData: { uid: '', query: {} },
    isLoading: false,
    horizontalAdvQueryLength: 0,
    cursorY: -1,
    cursorX: 0,
    isDropdownOpen: false
  }

  headerSearchRef: any = React.createRef()

  componentDidMount() {
    document.addEventListener('keydown', this.registerKeyBindings, false)
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.registerKeyBindings, false)
  }

  componentDidUpdate(prevProps) {
    try {
      const { uid, query, is_adv, is_custom } = this.props.queryObject

      const advSearchToggleCheck = !prevProps.isVisible && this.props.isVisible
      if (this.state.queryObjectData.uid !== uid) {
        if (advSearchToggleCheck) {
          this.compareAndParseQuery()
        } else {
          //set status of applied state, use to show when url refresh with adv query
          const queryTypeCheck = !is_custom && getQueryType(JSON.stringify(query)) === 'advanceQuery'
          const isAdvQuery = is_adv || (Object.keys(query || {}).length && queryTypeCheck)
          this.props.setIsAdvanceSearchApplied(isAdvQuery)
        }
      } else if (advSearchToggleCheck && !this.props.isAdvanceSearchApplied) {
        //clear unapplied query if any
        const advanceQueryArray = getInitAdvQueryArray()
        const horizontalAdvQueryLength = setCounterForAdvanceQuery(advanceQueryArray, -1)
        this.setState({ advanceQueryArray, horizontalAdvQueryLength })
        this.setResetCursor()
      }
    } catch (error) {
      console.log('AdvancedSearch ~ componentDidUpdate ~ error:', error)
    }
  }

  setResetCursor = (cursorY = -1, cursorX = 0) => {
    console.log('setResetCursor ', { cursorY, cursorX })
    this.setState({ cursorY, cursorX })
  }



  registerKeyBindings = (event) => {
    try {
      const { key } = event
      let { cursorY, cursorX } = this.state

      if (this.props.isVisible && !this.state.isDropdownOpen) {
        if (key === 'ArrowDown' && cursorY < this.state.horizontalAdvQueryLength) {
          cursorY = cursorY + 1
          console.log('ArrowDown ', { cursorY, cursorX })
          this.setState({ cursorY, cursorX: 0 })
        } else if (key === 'ArrowUp' && cursorY >= 0) {
          cursorY = cursorY - 1
          console.log('ArrowUp', { cursorY, cursorX })
          this.setState({ cursorY, cursorX: 0 })
        }

        else if (key === 'ArrowRight') {
          const queryArrayLength = getQueryArrayLengthByCursor(this.state.advanceQueryArray, cursorY)
          if (cursorX < queryArrayLength - 1) {
            cursorX = cursorX + 1
            this.setState({ cursorX })
            console.log('==> ArrowRight', { cursorY, cursorX })
          }
        } else if (key === 'ArrowLeft' && cursorX > 0) {
          cursorX = cursorX - 1
          console.log('ArrowLeft ', { cursorY, cursorX })
          this.setState({ cursorX })
        }
      }
    } catch (error) {
      console.log(" AdvancedSearch registerKeyBindings:", error)
    }
  }

  compareAndParseQuery = async () => {
    try {
      const { query, is_adv, is_custom } = this.props.queryObject
      const stringiFiedStateQuery = JSON.stringify(this.state.queryObjectData.query)
      const stringiFiedPropsQuery = JSON.stringify(query)

      // console.log('parse2 ', stringiFiedPropsQuery !== stringiFiedStateQuery)
      if (stringiFiedStateQuery !== stringiFiedPropsQuery) {
        this.setState({ queryObjectData: this.props.queryObject, isLoading: true })

        const queryTypeCheck = !is_custom && getQueryType(stringiFiedPropsQuery) === 'advanceQuery'
        if (query && (is_adv || queryTypeCheck)) {
          const data = await advanceQueryParser({
            query: query,
            selectedModule: this.props.selectedModule,
            fetchData: this.props.fetchData
          })
          const horizontalAdvQueryLength = setCounterForAdvanceQuery(data, -1)
          this.setState({ advanceQueryArray: data, isLoading: false, horizontalAdvQueryLength })
          this.props.setIsAdvanceSearchApplied(true)
          this.setResetCursor()
          // console.log('should parse only once parse 4 ', data)
        } else {
          // console.log('else case empty parse 5  ')
          this.props.setIsAdvanceSearchApplied(false)
          const advanceQueryArray = getInitAdvQueryArray()
          this.setResetCursor()
          const horizontalAdvQueryLength = setCounterForAdvanceQuery(advanceQueryArray, -1)
          this.setState({ advanceQueryArray, isLoading: false, horizontalAdvQueryLength })
        }
      }
    } catch (error) {
      console.log(' compareAndParseQuery ~ error:', error)
    }
  }

  handleConditionClick = ({ action, queryObject }) => {
    let { advanceQueryArray } = this.state
    let ct_status = queryObject.ct_status || {}
    let { show_ct, ...restCtStatus } = ct_status
    restCtStatus = Object.keys(restCtStatus).length ? restCtStatus : ''

    if (action === 'addCondition') {
      queryObject.queryArray.push({ key: [], operator: [], value: [] })
    }

    if (action === 'addSubCondition') {
      if (Array.isArray(queryObject.children)) {
        queryObject.children.push({
          queryType: 'matchAll',
          children: [],
          queryArray: [{ key: [], operator: [], value: [] }],
          ct_status: restCtStatus
        })
      } else {
        queryObject.children = [
          {
            queryType: 'matchAll',
            children: [],
            queryArray: [{ key: [], operator: [], value: [] }],
            ct_status: restCtStatus
          }
        ]
      }
    }
    const horizontalAdvQueryLength = setCounterForAdvanceQuery(advanceQueryArray, -1)
    this.setState({ advanceQueryArray: [...advanceQueryArray], horizontalAdvQueryLength })
    this.setResetCursor()
  }

  resetQueryObjectData = () => {
    if (this.props.isAdvanceSearchApplied) {
      //changing state queryObjectData , enables to run run parsing as raw query object has change, get the change from url
      this.setState({ queryObjectData: { query: '', uid: Date.now() } })
    }
  }

  handleQueryRemove = ({ queryObject, currentAdvQueryArray, queryObjIndex, queryIndex, action }) => {
    let { advanceQueryArray } = this.state

    if (action === 'removeQueryGroup') {
      currentAdvQueryArray.splice(queryObjIndex, 1)
    }

    if (action === 'removeQuery') {
      //removing query from queryArray by index
      const deletedQuery = queryObject.queryArray.splice(queryIndex, 1)

      //Deleting localized Query
      const isLocalizedQuery = queryObject.queryArray[queryIndex]?.queryType === 'localizedInLabel'
      if (
        this.props.selectedModule === 'entries' &&
        deletedQuery[0].queryType === 'languageLabel' &&
        isLocalizedQuery
      ) {
        queryObject.queryArray.splice(queryIndex, 1)
      }

      if (this.props.selectedModule === 'entries' && deletedQuery[0].queryType === 'contentTypeLabel') {
        let errorMessage = updateSelectedContentTypeStatus({ queryObject, type: 'delete' })
        if (errorMessage) {
          notify(errorMessage, 'error')
        }
      }
    }

    //handling match grp clear if no query or child present
    // if (!queryObject.children.length && !queryObject.queryArray.length && !queryObject.root) {
    //   currentAdvQueryArray.splice(queryObjIndex, 1)
    // }

    const horizontalAdvQueryLength = setCounterForAdvanceQuery(advanceQueryArray, -1)
    this.setState({ advanceQueryArray: [...advanceQueryArray], horizontalAdvQueryLength })
    this.resetQueryObjectData()
    this.setResetCursor()
    // if (this.headerSearchRef.current) {
    //   this.headerSearchRef.current.click()
    //   this.headerSearchRef.current?.focus()
    // }
  }

  updateAdvancedQueryArray = (argsData) => {
    let {
      currentQuery = {},
      queryArray,
      currentQueryIndex,
      action,
      queryObject,
      selectedOption,
      parentQueryObject
    } = argsData

    let { advanceQueryArray } = this.state
    const { key = [], operator = [], value = [] } = currentQuery
    const isQueryCompleted = key.length && operator.length && value.length

    if (action === 'updateQueryArray') {
      queryArray.splice(currentQueryIndex, 1, currentQuery)

      const isLocalizedQuery = queryArray[currentQueryIndex + 1]?.queryType === 'localizedInLabel'
      if (
        this.props.selectedModule === 'entries' &&
        // deletedQuery[0].queryType === 'languageLabel' &&
        isLocalizedQuery
      ) {
        //Deleting localized Query
        queryArray.splice(currentQueryIndex + 1, 1)

      }

      //adding localized Query after lang
      if (this.props.selectedModule === 'entries' && currentQuery.queryType === 'languageLabel' && isQueryCompleted) {

        if (currentQuery.value[0]?.value === '$allLanguages' && !(currentQuery.operator[0]?.value === '$eq')) {
          currentQuery.value = [];
        }

        if (currentQuery.value.length && currentQuery.value[0]?.value !== '$allLanguages') {
          const selectedLanguage = currentQuery.value[0].value
          const localizeIn = JSON.parse(JSON.stringify(localizedData))
          //insert but don't delete any
          queryArray.splice(currentQueryIndex + 1, 0, { ...localizeIn, selectedLanguage })
        }
      }

      // DONT REMOVE THIS, this is commented for SEPT 11 release
      // null not null check
      if ((this.props.selectedModule === 'entries' || this.props.selectedModule === 'assets') && currentQuery.operator[0].value === '$exists') {
        let existsValue = currentQuery.operator[0].label.toLowerCase() === 'is empty' ? false : true;
        currentQuery.value = [{ label: '', value: existsValue }];
      }

      // if ((this.props.selectedModule === 'entries' || this.props.selectedModule === 'assets') && currentQuery.value.length && currentQuery.operator[0].value !== '$not') {
      //   let existsLabel = typeof currentQuery.value[0].label['$regex'] !== undefined ? currentQuery.value[0].label['$regex'] : currentQuery.value[0].label;
      //   let existsValue = typeof currentQuery.value[0].value['$regex'] !== undefined ? currentQuery.value[0].value['$regex'] : currentQuery.value[0].value;
      //   currentQuery.value = [{ label: existsLabel, value: existsValue }];
      // } else if ((this.props.selectedModule === 'entries' || this.props.selectedModule === 'assets') && currentQuery.value.length && currentQuery.operator[0].value === '$not') {
      //   let existsLabel = typeof currentQuery.value[0].label['$regex'] !== undefined ? currentQuery.value[0].label['$regex'] : currentQuery.value[0].label;
      //   let existsValue = typeof currentQuery.value[0].value['$regex'] !== undefined ? currentQuery.value[0].value['$regex'] : currentQuery.value[0].value;
      //   currentQuery.value = [{ label: { '$regex': existsLabel }, value: { '$regex': existsValue } }];
      // }

      if ((this.props.selectedModule === 'entries' || this.props.selectedModule === 'assets') && currentQuery.value.length) {
        let existsLabel = typeof currentQuery.value[0].label['$regex'] !== "undefined" ? currentQuery.value[0].label['$regex'] : currentQuery.value[0].label;
        let existsValue = typeof currentQuery.value[0].value['$regex'] !== "undefined" ? currentQuery.value[0].value['$regex'] : currentQuery.value[0].value;
        currentQuery.value = currentQuery.operator[0].value === '$not' ? [{ label: { '$regex': existsLabel }, value: { '$regex': existsValue } }] : [{ label: existsLabel, value: existsValue }];
      }



      const horizontalAdvQueryLength = setCounterForAdvanceQuery(advanceQueryArray, -1)
      this.setState({ advanceQueryArray: [...advanceQueryArray], horizontalAdvQueryLength })

      if (this.props.selectedModule === 'entries') {
        let errorMessage = updateSelectedContentTypeStatus({ queryObject, parentQueryObject, type: 'default' })
        if (errorMessage) {
          notify(errorMessage, 'error')
        }
      }
    }

    if (action === 'updateMatchTag') {
      queryObject.queryType = selectedOption.value
      const horizontalAdvQueryLength = setCounterForAdvanceQuery(advanceQueryArray, -1)
      this.setState({ advanceQueryArray: [...advanceQueryArray], horizontalAdvQueryLength })
    }
    this.resetQueryObjectData()
    // if (this.headerSearchRef.current) {
    //   this.headerSearchRef.current?.focus()
    //   this.headerSearchRef.current.click()
    // }
    console.log('%c updateAdvancedQueryArray', 'background: #d11450; color: #fff', advanceQueryArray)
  }

  handleClearInput = () => {
    console.log('handleClearInput')
    let advanceQueryArray = getInitAdvQueryArray()
    const horizontalAdvQueryLength = setCounterForAdvanceQuery(advanceQueryArray, -1)
    this.setState({ advanceQueryArray, queryObjectData: { query: '', uid: Date.now() }, horizontalAdvQueryLength })
    this.setResetCursor()
    this.props.setIsAdvanceSearchApplied(false)
    this.props.onClearInput && this.props.onClearInput({
      selectedModule: this.props.selectedModule
    })
    // if (this.headerSearchRef.current) {
    //   this.headerSearchRef.current.click()
    //   this.headerSearchRef.current?.focus()
    // }
  }

  handleSearchSubmit = async () => {
    const { advanceQueryArray } = this.state
    let errorMessage = ''
    let errorObject = {
      isQueryEmpty: false,
      isErrorCursorFound: false,
      errorMessage: ''
    }
    validateAdvanceQuery(advanceQueryArray, errorObject)
    console.log('handleSearchSubmit -> errorObject', errorObject, advanceQueryArray)

    if (errorObject.isQueryEmpty) {
      errorMessage = advance_query_errors.no_conditions
      this.setState({ errorMessage })
      notify(errorMessage, 'error')
      return
    }
    if (errorObject.isErrorCursorFound) {
      errorMessage = errorObject.errorMessage
      this.setState({ errorMessage })

      notify(errorMessage, 'error')
      return
    }

    this.setState({ errorMessage: '' })
    this.props.setIsAdvanceSearchApplied(true)
    const queryObjectsForAdvQuery = buildQueryObjectForAdvCase(this.state.advanceQueryArray, this.props.selectedModule)
    // keeping same queryobject as in url, will restrict did update parsing ro re run after apply
    this.setState({ queryObjectData: { query: queryObjectsForAdvQuery, uid: Date.now() } })

    // //todo comment this after testing
    // const data = await advanceQueryParser({
    //   query: queryObjectsForAdvQuery,
    //   selectedModule: this.props.selectedModule,
    //   fetchData: this.props.fetchData
    // })
    // console.log('=====> AdvancedSearch ~ advanceQueryParser:', data, queryObjectsForAdvQuery)

    // this.setState({ advanceQueryArray: data })
    // return

    this.props.setAdvSearchVisibility(false)
    this.props.onSearchSubmit({
      type: 'advanceQuery',
      selectedModule: this.props.selectedModule,
      queryObject: queryObjectsForAdvQuery
    })
    console.log(':: => handleSearchSubmit AdvSearch', queryObjectsForAdvQuery)
  }

  setDropdownOpen = (isDropdownOpen) => {
    this.setState({ isDropdownOpen })
  }

  render() {
    return (
      <div
        className={classNames(
          'AdvancedQueryView',
          this.props.noSideNav && 'no__sidenav',
          this.props.isVisible && 'AdvancedQueryView__show',
          !this.props.isVisible && 'AdvancedQueryView__hide',
          this.props.breadcrumbMargin && 'breadcrumb__margin'
        )}
        data-test-id="cs-advance-search-query-container">
        <AdvanceSearchHeader
          headerSearchRef={this.headerSearchRef}
          isVisible={this.props.isVisible}
          setAdvSearchVisibility={this.props.setAdvSearchVisibility}
          selectedModule={this.props.selectedModule}
          handleClearInput={this.handleClearInput}
          handleSearchSubmit={this.handleSearchSubmit}
          key={this.state.cursorY + this.state.cursorX}
        />
        <div className="AdvancedQueryView__body-wrapper">
          <InfoBanner
            handleInfoBannerAction={this.props.handleInfoBannerAction}
          />
          <div className="AdvancedQueryView__body" key={this.state.cursorY + this.state.cursorX}>
            <RenderAdvanceQuery
              advanceQueryArray={this.state.advanceQueryArray}
              handleConditionClick={this.handleConditionClick}
              handleQueryRemove={this.handleQueryRemove}
              fetchData={this.props.fetchData}
              updateAdvancedQueryArray={this.updateAdvancedQueryArray}
              selectedModule={this.props.selectedModule}
              isTaxonomyPlanEnabled={this.props.isTaxonomyPlanEnabled}
              cursorY={this.state.cursorY}
              cursorX={this.state.cursorX}
              setDropdownOpen={this.setDropdownOpen}
              isDropdownOpen={this.state.isDropdownOpen}
              isVisible={this.props.isVisible}
            />
          </div>
          {this.state.isLoading && <LoaderV2 />}
        </div>
      </div>
    )
  }
}

const AdvanceSearchWrapper = (props) => {
  const { testId } = props
  let [isVisible, setAdvSearchVisibility] = useState(false)
  let [isAdvanceSearchApplied, setIsAdvanceSearchApplied] = useState(false)

  const openAdvancedSearch = () => {
    // if (!isOpen) {
    //   setIsOpen(true)
    // }
    setAdvSearchVisibility(true)
  }

  // let onCloseAdvancedSearch = () => {
  //   setIsOpen(false)
  // }

  return (
    <div className="AdvanceSearchV2Container" data-test-id="cs-advance-search-v2">
      <Button
        buttonType="tertiary"
        size="regular"
        version="v2"
        onClick={openAdvancedSearch}
        testId={`${isAdvanceSearchApplied ? testId + '-modify' : testId}`}>
        {isAdvanceSearchApplied ? 'Modify Advanced Search' : 'Advanced Search'}
      </Button>
      <AdvanceSearchPortal>
        <AdvancedSearch
          setIsAdvanceSearchApplied={setIsAdvanceSearchApplied}
          setAdvSearchVisibility={setAdvSearchVisibility}
          isVisible={isVisible}
          isAdvanceSearchApplied={isAdvanceSearchApplied}
          {...props}
        />
      </AdvanceSearchPortal>
    </div>
  )
}

export default AdvanceSearchWrapper
